export const NoMatch = (): JSX.Element => <h1>{'404 - Whoopsie'}</h1>;
